import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { dataLayerRemoveFromCart } from '../Services/Gtm.service';
import { isAtMaxQuantity, maxQuantityText } from '../Services/purchaseRestriction';

const GetProduct = (row, updateOrderRowQuantity, removeOrderRow, maxNoticeRow, setMaxNoticeRow) => {
  const atMax = isAtMaxQuantity(row);
  const removeOrderRowWithTracking = (articleNumber) => {
    try {
      dataLayerRemoveFromCart([row.gtmEcommerceItem]);
    } catch (e) {
      console.warn(e);
    }

    return removeOrderRow(articleNumber);
  };

  return (
    <div className="item">
      <div className="image">
        <img src={row.image} alt={row.name} />
      </div>
      <div className="name-and-price">
        <div className="name">
          {row.isPartnerProduct && row.partnerLogoUrl && (
            <img className="partner-badge partner-badge--large" src={row.partnerLogoUrl} alt={row.externalSeller} />
          )}
          <a href="#">{row.name}</a>
        </div>
        {row.totalCampaignPrice ? (
          <div className="price">
            <div className="prices">
              <span className="new">{row.totalCampaignPrice}</span>
              <span className="old">({row.totalPrice})</span>
            </div>
          </div>
        ) : (
          <div className="price">
            <div className="prices">
              <span className="regular">{row.totalPrice}</span>
            </div>
          </div>
        )}
      </div>
      <div className="stock-and-erase">
        <div className="stock">
          <div
            className={
              row.isInStock ? 'stock-info in-stock' : 'stock-info out-of-stock'
            }
          >
            {row.deliveryStatusText}
          </div>
          <div className="amount">
            <div className="number-input">
              <button
                onClick={() =>
                  updateOrderRowQuantity(row.articleNumber, row.quantity - 1)
                }
              ></button>
              <input
                readOnly={true}
                className="quantity"
                min="0"
                name="quantity"
                value={row.quantityString}
                type="number"
              />
              <button
                onClick={() =>
                  atMax
                    ? setMaxNoticeRow(row.rowSystemId)
                    : updateOrderRowQuantity(row.articleNumber, row.quantity + 1)
                }
                className={atMax ? 'plus at-max' : 'plus'}
                aria-disabled={atMax}
              ></button>
            </div>
          </div>
          {atMax && maxNoticeRow === row.rowSystemId && (
            <div className="max-quantity-notice">{maxQuantityText(row)}</div>
          )}
        </div>
        <div className="erase">
          <a
            href="#"
            onClick={() => removeOrderRowWithTracking(row.articleNumber)}
          >
            Ta bort
          </a>
        </div>
      </div>
    </div>
  );
};

const MiniCart = ({
  toggle,
  updateOrderRowQuantity,
  removeOrderRow,
  orderRows,
}) => {
  const dispatch = useDispatch();
  const [maxNoticeRow, setMaxNoticeRow] = useState(null);
  const {
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    discount,
    discountDescription,
    grandTotal,
    partnerNoticeHtmlList,
  } = useSelector((state) => state.cart);
  /* 
        <div className="upsell-header">
          <h3>Du kanske �ven beh�ver..</h3>
        </div>
    
        <div className="upsell-items">
          <div className="item">
            <div className="image reduced-prize" data-discount="-35%">
              <img src="/ui/assets/images/product-double-chair-wagon.jpg" alt="Product name"/>
            </div>
            <div className="text">
              <span className="brand">Emmaljunga</span>
              <span className="name">Baby Jogger City Mini GT2 Double Jet</span>
              <span className="price red">12 995 kr</span>
            </div>
          </div>
        </div>
  */
  if (showInfo) {
    document.body.classList.add('mini-cart-active');
  } else {
    document.body.classList.remove('mini-cart-active');
  }
  return (
    <div>
      <div className={`mini-cart-background ${showInfo ? 'active' : ''}`}></div>
      <div className={`mini-cart-holder ${showInfo ? 'active' : ''}`}>
        <div className="mini-cart">
          <div className="header">
            <h3>
              {translate('cart.ContainsMessagePart1')} {orderRows.length}{' '}
              {translate('cart.ContainsMessagePart2')}
            </h3>
            <a href="#" onClick={() => toggle()} className="mini-cart-toggle">
              <img
                src="/ui/assets/icons/xmark-regular.svg"
                alt="Stäng mini cart"
              />
            </a>
          </div>
          <div className="item-list">
            {orderRows.map((row) =>
              GetProduct(row, updateOrderRowQuantity, removeOrderRow, maxNoticeRow, setMaxNoticeRow)
            )}
          </div>
          {discountDescription && discount && (
            <div className="values bigger">
              <div>{discountDescription}</div>
              <div className="red">{discount}</div>
            </div>
          )}
          {partnerNoticeHtmlList && partnerNoticeHtmlList.length > 0 && (
            <div className="partner-notices partner-notices--minicart">
              {partnerNoticeHtmlList.map((html, index) => (
                <div key={index} className="partner-notice partner-notice--cart"
                     dangerouslySetInnerHTML={{ __html: html }} />
              ))}
            </div>
          )}
          <div className="values bigger">
            <div>Totalt</div>
            <div className="black">{grandTotal}</div>
          </div>

          <div className="button-holder">
            <a href={checkoutUrl} className="button">
              {translate('minicart.checkout')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
